<div class="bg-coomeva">
    <div>
        <div class="matricularCuenta">
            
        </div>
        <div class="loginForm card card-block login-card">
            <div class="container-mobil">
                <!-- <div class="login-img-mobil"></div> -->
                <h3>Matricular Cuenta</h3>
                <!-- <h4 style="text-align: center"><b>Ingresa con tu Cuenta Coomeva</b></h4> -->
            </div>
            <div class="conteiner-h">
                <!-- <div class="login-img"></div> -->
                <div class="form-group">
                    <div class="">
                        <h3 class="form-label" style="text-align: center; padding-left: 10px;"></h3>
                        <!-- <h4 style="text-align: center"><b>Ingresa con tu Cuenta Coomeva</b></h4> -->
                    </div>
                    <div class="input-group">
                        <span class="input-group-addon addon-left" id="tipDoc">
                                    <i class="fas fa-user fa-fw"></i>
                                  </span>
                        <select class="form-control input-login" required id="tipodoc" name="tipodoc" [(ngModel)]="login.tipDoc" placeholder="Tipo Documento">
                            <option value="" disabled selected>Tipo Documento</option>
                            <option value="1" >Cédula de Ciudadanía</option> 
                            <option value="2" >Cédula Extranjeria</option>
                            <option value="4">Tarjeta Identidad</option>
                            <option value="5">Pasaporte</option>
                            <option value="6">Registro Civil</option>
                            <option value="9">Carnet Diplomático </option>
                        </select>
                    </div>
                    <div class="input-group">
                        <span class="input-group-addon addon-left" id="numDoc">
              <i class="fas fa-unlock-alt fa-fw"></i>
            </span>
                        <input class="form-control input-login " [(ngModel)]="login.numDoc" placeholder="N&uacute;mero Documento" type="number" />
                    </div>
                    <div class="input-group" *ngIf="showFieldToken">
                        <span class="input-group-addon addon-left" id="token">
              <i class="fas fa-unlock-alt fa-fw"></i>
            </span>
                        <input class="form-control input-login " [(ngModel)]="login.token" placeholder="C&oacute;digo Seguridad" type="text" />
                    </div>

                    <div class="recaptcha-container" [hidden]="showFieldToken">
                        <div id="g-recaptcha"></div>
                    </div>

                    <button style="margin-top: 10px;border: 1px solid white;" class=" btn btn-icon btn-defaulty button-normal-circle" (click)="OnClickEntry()" *ngIf="!showFieldToken">
            Continuar
          </button>
                    <button style="border: 1px solid white;" class=" btn btn-icon btn-defaulty button-normal-circle" (click)="reenviarCodigo()" *ngIf="showFieldToken">
            Reenviar Código
</button>
                    <button style="margin-top: 10px;border: 1px solid white;" class=" btn btn-icon btn-defaulty button-normal-circle" (click)="validarToken()" *ngIf="showFieldToken">
                        Continuar
          </button>


                </div>
            </div>
        </div>
        
        <div class="activaCuenta card card-block">
            <!--<span style="color: white;">ACTIVA TU D&Eacute;BITO AUTOM&Aacute;TICO</span>
            <br>-->
        </div><div class="mensajeActiva card card-block">
            <!--<span style="color: white;">Estar al d&iacute;a con tu cooperativa es vivir tu tranquilidad, realiza tus pagos de forma tranquila y segura. 
            </span>
            <br>-->
            <span><a style="color: white; font-size: 18px; position: absolute; top: 83%; left: 20%; font-size: large; z-index: 1000;" target="_blank_" href="https://www.coomeva.com.co/publicaciones/155258/estar-al-dia-activando-tu-debito-automatico-es-una-eleccion-que-te-premia/">
                *Conoce t&eacute;rminos y condiciones
            </a></span>
        </div>
        <div class="imgCoomeva" style="background-color: transparent;
        margin: auto;
        width: auto;
        border: 0px;
        float: right;
        width: 20%;
        left: 22%;
        padding-top: 28%;
        position: relative;
        margin-top: 36%;"></div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.html